import { render, staticRenderFns } from "./BarTitle.vue?vue&type=template&id=929d5dc6&scoped=true"
import script from "./BarTitle.vue?vue&type=script&lang=js"
export * from "./BarTitle.vue?vue&type=script&lang=js"
import style0 from "./BarTitle.vue?vue&type=style&index=0&id=929d5dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929d5dc6",
  null
  
)

export default component.exports